import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22aafc36"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "base_select_button_selected"
}
const _hoisted_2 = {
  key: 1,
  class: "base_select_button_placeholder"
}

import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSelectButton',
  props: {
  placeholder: {
    type: String as PropType<string>,
    required: true,
  },
  modelValue: {
    type: String as PropType<string>,
    default: '',
  },
  isError: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["click", "clear", "update:modelValue"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'click'): true;
  (e: 'clear'): true;
  (e: 'update:modelValue', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const handleClick = (e: Event) => {
  // クリアボタン押下時は何もしない
  if (e.target && (e.target as Element).className === 'base_select_button_cancel') return;
  emits('click');
};

const clear = () => {
  emits('update:modelValue', '');
  // 念のためclearイベントを親にも渡す
  emits('clear');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["base_select_button", { 'is-error': props.isError }]),
    onClick: handleClick
  }, [
    (props.modelValue)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(props.modelValue), 1))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.placeholder), 1)),
    (props.modelValue)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "base_select_button_cancel",
          onClick: clear
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})